import React from "react";
import { JoyrideReusableTour } from "@cd/sdds-common-components-react";
import generateEquipmentTourStepsByRole from "./sc-tour-helper";

type SCSupportedServicesTourProps = {
  loggedInProfileInfo: {
    role: string;
  };
  start: boolean;
  isButtonLabelHide?: boolean;
  onTourClose?: (data: any) => void;
};

const SCSupportedServicesTour = ({ loggedInProfileInfo, start, isButtonLabelHide, onTourClose}:SCSupportedServicesTourProps ) => {
  return (
    <JoyrideReusableTour
      loggedInProfileInfo={loggedInProfileInfo}
      stepsByRole={(role): TourStep[] => generateEquipmentTourStepsByRole(role, 'supportedServices') as TourStep[]}
      buttonLabel="JR_EnabledServices"
      tourKey="sa-details-tour"
      start={start}
      onTourClose={onTourClose}
      isButtonLabelHide={isButtonLabelHide}
    />
  );
};

export default SCSupportedServicesTour;
